"use client"

import { type ReactNode } from "react"
import { useCountry } from "@/components/layout/country-provider"
import { isAllowedInCountry, type GateId } from "@/lib/country-gates"

/**
 * Declarative client-side country gate. Renders `children` when the
 * visitor's country is in the gate's allow-list, otherwise renders
 * `fallback` (default: `null`).
 *
 * Server components do NOT use this — they already have `country` as a
 * route param, so they call `isAllowedInCountry(id, country)` directly.
 */
export function CountryGate({
  id,
  children,
  fallback = null,
}: {
  id: GateId
  children: ReactNode
  fallback?: ReactNode
}) {
  const { code } = useCountry()
  return <>{isAllowedInCountry(id, code) ? children : fallback}</>
}
